<template>
  <div>
    <div class="usertop">
      <router-link to="/" class="logomid">
        <img src="~img/logomid.png" alt="" />
      </router-link>
    </div>
    <h1>
      <router-link to="/">源石阅读</router-link>
    </h1>
  </div>
</template>

<script>
export default {};
</script>
/* 覆盖element-ui form里的样式 */
<style>
.loginall .el-input__inner {
  border: 1px solid rgba(211, 211, 211, 1);
  /* margin-bottom: 24px; */
  height: 46px;
}
.el-input__inner::placeholder {
  color: #999;
}
.el-input-group--append .el-input__inner {
  border: 1px solid rgba(211, 211, 211, 1);
  margin-bottom: 0px;
  height: 46px;
}
.el-input-group__append {
  padding: 0;
  width: 80px;
  height: 44px;
}
.login-form-input .el-input__inner:focus {
  box-shadow: 0px 0px 8px 0px rgba(176, 214, 240, 1);
  border: 1px solid rgba(72, 162, 223, 1);
}
.el-button {
  width: 100%;
  height: 46px;
  color: #fff;
  background: rgba(72, 162, 223, 1);
}
.el-button:focus {
  background: rgba(72, 162, 223, 1);
  border-color: rgba(72, 162, 223, 1);
  color: #fff;
  width: 100%;
  height: 46px;
}
.el-button:hover {
  background: rgba(72, 162, 223, 1);
  border-color: rgba(72, 162, 223, 1);
  color: #fff;
  width: 100%;
  height: 46px;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgba(72, 162, 223, 1);
  border-color: rgba(72, 162, 223, 1);
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(72, 162, 223, 1);
}
/* .el-form-item {
  margin-bottom: 0px
} */
.loginWrap .loginbtn {
  margin-bottom: 5px;
}
</style>
<style lang="stylus" scoped>
.usertop
    width 100%
    height 140px
    background rgba(25, 31, 69, 1)
    position relative
    .logomid
        display inline-block
        position absolute
        left 50%
        margin-left -68px
        width 136px
        height 181px
        bottom -75px
        img
            width 100%
            height 100%
h1
    text-align center
    margin-top 50px
    a
        font-size 38px
        color #191F45
</style>
